import Steps, { StepsProps, Step } from "./Steps";

export { Steps, StepsProps, Step };

export default Steps;
